import { updateState } from '../../shared/mutations';
import { VideoTemplateStateContent } from '../../types';

export function setBackgroundColor(
  state: VideoTemplateStateContent,
  color: string,
) {
  return updateState(state, {
    backgroundColor: color,
  });
}
